import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { SETTINGS_PROFILE } from '../../../../routes/routeConstants';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import InfoOutlinedIcon from '../../../Icons/InfoOutlinedIcon';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface VehicleTypeNotInFleetModalProps {
  // Runs the original action (e.g. Make Active) when the user chooses to continue
  onContinue: () => void;
}

const VehicleTypeNotInFleetModal: React.FC<VehicleTypeNotInFleetModalProps> = ({
  onContinue,
}) => {
  const modalContext = useContext(ModalContext);
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    modalContext?.setShowModal(false);
    navigate(`/${SETTINGS_PROFILE}`);
  };

  const handleContinue = () => {
    modalContext?.setShowModal(false);
    onContinue();
  };

  return (
    <ModalContainer label=''>
      <InfoArea>
        <IconBox>
          <InfoOutlinedIcon />
        </IconBox>
        <Title>Update your fleet in Settings</Title>
        <Message>
          Vehicles that were not selected during sign-up have been disabled, and
          their assigned drivers have been unassigned.
        </Message>
      </InfoArea>
      <ButtonArea>
        <FormSubmitButton
          className='clear fill border-blue color-blue large'
          onClick={handleGoToSettings}
          btnType='button'
        >
          Go to Settings
        </FormSubmitButton>
        <FormSubmitButton
          className='fill large'
          onClick={handleContinue}
          btnType='button'
        >
          Continue
        </FormSubmitButton>
      </ButtonArea>
    </ModalContainer>
  );
};

export default VehicleTypeNotInFleetModal;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px 32px;
  background-color: #f5f7fb;
  text-align: center;
`;

const IconBox = styled.div`
  display: grid;
  place-items: center;
  width: 104px;
  height: 104px;
  border-radius: 16px;
  background-color: #e9f0fd;
  color: ${({ theme }) => theme.palette.blueColor};

  & svg {
    width: 36px;
    height: 36px;
  }
`;

const Title = styled.div`
  margin-top: 16px;
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.palette.primaryTextColor};
`;

const Message = styled.div`
  font-size: 14px;
  line-height: 26px;
  color: #6b7280;
`;

const ButtonArea = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`;
